import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Vardhaman Wire</h1>
          <p>45+ Years of Excellence in Wire & Steel Industry</p>
        </div>
      </section>

      {/* Company Profile Section */}
      <section className="company-profile">
        <div className="container">
          <div className="profile-content">
            <div className="profile-text">
              <h2>🏢 Company Profile</h2>
              <p>
                <strong>Vardhaman Group</strong> has been a trusted name in the wire and steel industry 
                for over 45 years. Based in Kolhapur, Maharashtra, we have built our reputation on 
                reliability, quality, and exceptional customer service.
              </p>
              
              <div className="company-stats">
                <div className="stat">
                  <h3>45+</h3>
                  <p>Years of Experience</p>
                </div>
                <div className="stat">
                  <h3>3</h3>
                  <p>States Served</p>
                </div>
                <div className="stat">
                  <h3>1000+</h3>
                  <p>Satisfied Customers</p>
                </div>
              </div>
            </div>
            
            <div className="profile-image">
              <div className="image-placeholder">
                <h3>🏭</h3>
                <p>Vardhaman Wire Factory</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy">
        <div className="container">
          <h2>Our Philosophy & Values</h2>
          <div className="philosophy-grid">
            <div className="philosophy-card">
              <h3>🤝 Independence & Partnership</h3>
              <p>We maintain our independence while building strong, dependable partnerships with our clients and suppliers.</p>
            </div>
            
            <div className="philosophy-card">
              <h3>🔄 Repeat Business Focus</h3>
              <p>Our success is measured by repeat business and long-term relationships, not just immediate profits.</p>
            </div>
            
            <div className="philosophy-card">
              <h3>🛠️ After-Sales Service</h3>
              <p>We provide comprehensive after-sales support including delivery, claims processing, and flexible payment terms.</p>
            </div>
            
            <div className="philosophy-card">
              <h3>🌱 Environmental Responsibility</h3>
              <p>We are environmentally conscious and socially responsible in all our business practices.</p>
            </div>
            
            <div className="philosophy-card">
              <h3>💎 Commitment Over Profit</h3>
              <p>Profit is not our sole motive; commitment to clients, suppliers, and society is equally important.</p>
            </div>
            
            <div className="philosophy-card">
              <h3>📈 Continuous Growth</h3>
              <p>We focus on sustainable growth while maintaining quality and service standards.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Business Reach Section */}
      <section className="business-reach">
        <div className="container">
          <h2>📍 Our Business Reach</h2>
          <div className="reach-content">
            <div className="reach-map">
              <h3>Service Areas</h3>
              <ul>
                <li>✅ Maharashtra</li>
                <li>✅ Goa</li>
                <li>✅ Karnataka</li>
                <li>✅ Nationwide Distribution Network</li>
              </ul>
            </div>
            
            <div className="office-locations">
              <h3>Office Locations</h3>
              <div className="location">
                <h4>📍 Kolhapur Head Office</h4>
                <p>Plot no D-55, Gokulshirgaon MIDC<br />Kolhapur - 416234, Maharashtra</p>
                <p>
                  <a
                    href="https://maps.app.goo.gl/VWbetrScSxLM1apA6?g_st=aw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View on Google Maps
                  </a>
                </p>
                <p>📱 Mob: +91-9890749013 / +91-9028293304</p>
              </div>
              
              <div className="location">
                <h4>📍 Pune Operations</h4>
                <p>6/1/1, Near Bazare Petrol Pump, Uruli Devachi,<br />Handewadi-Katraj Road, Pune - 412308</p>
                <p>
                  <a
                    href="https://maps.app.goo.gl/RV39i8TFpzn1dxGW9?g_st=aw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View on Google Maps
                  </a>
                </p>
                <p>📞 +91 9372937239</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Commitment Section */}
      <section className="quality-commitment">
        <div className="container">
          <h2>Our Quality Commitment</h2>
          <div className="quality-points">
            <div className="quality-point">
              <h3>🏭 Trusted Brands</h3>
              <p>We partner with renowned brands like TATA, ESSAR, BHUSHAN, and JSW to ensure premium quality products.</p>
            </div>
            
            <div className="quality-point">
              <h3>🔍 Quality Control</h3>
              <p>Rigorous quality checks at every stage ensure that our products meet industry standards and customer expectations.</p>
            </div>
            
            <div className="quality-point">
              <h3>📋 Comprehensive Range</h3>
              <p>From basic binding wire to complex structural steel, we offer a complete range of products for diverse applications.</p>
            </div>
            
            <div className="quality-point">
              <h3>🚚 Reliable Delivery</h3>
              <p>Efficient logistics and delivery systems ensure timely supply to our customers across multiple states.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="about-contact">
        <div className="container">
          <h2>Get in Touch</h2>
          <p>Ready to partner with us? Contact our team today for all your wire and steel requirements.</p>
          <div className="contact-buttons">
            <a href="tel:+919404257415" className="btn btn-primary">📞 Call Now</a>
            <a href="/products" className="btn btn-secondary">View Products</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;